/* MAUD motion backgrounds — layer, theme-editor hook, comparison switcher,
   and the BEAMS show sequencer.
   Mode is set early (theme.liquid / maud-motion-bg section). */
(function () {
  var root = document.documentElement, MODES = ['off', 'beams', 'lasers', 'pulse', 'grain'];
  var layer, rig, show = null;

  function cur() { return root.getAttribute('data-maud-bg') || 'off'; }
  function set(m) {
    root.setAttribute('data-maud-bg', m);
    try { sessionStorage.setItem('maudBg', m); } catch (e) {}
    document.querySelectorAll('.maud-bg-pick button').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.m === m ? 'true' : 'false'); });
    sync();
  }

  /* ================= BEAMS: the show =================
     Gesaffelstein-show grammar: stark symmetry, slow imposing moves, hard cuts.
     A "look" = a target state for every fixture. The sequencer picks a new look at
     random every 4/8/16 beats (never the same one twice in a row, weighted so the big
     looks come round more than the breakdowns), and most looks move within themselves
     on the beat (sweeps, scissors, chases, hits). */
  var TOP = 8, FLOOR = 2;

  function beatMs() {
    var v = getComputedStyle(root).getPropertyValue('--mbg-beat').trim();
    var n = parseFloat(v) || 0.4839;
    return (v.indexOf('ms') > -1 ? n : n * 1000);
  }
  function speed() { return parseFloat(getComputedStyle(root).getPropertyValue('--mbg-speed')) || 1; }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  function buildRig() {
    rig = document.createElement('div');
    rig.className = 'maud-rig';
    var h = '<span class="haze"></span><span class="haze"></span>';
    for (var i = 0; i < TOP; i++) h += '<b></b>';
    for (var j = 0; j < FLOOR; j++) h += '<b class="floor"></b>';
    h += '<span class="wash"></span>';
    rig.innerHTML = h;
    layer.appendChild(rig);
    rig.top = [].slice.call(rig.querySelectorAll('b:not(.floor)'));
    rig.floor = [].slice.call(rig.querySelectorAll('b.floor'));
    rig.wash = rig.querySelector('.wash');
    rig.top.forEach(function (b, i) { b.i = i; b.x = 6 + i * (88 / (TOP - 1)); b.style.left = b.x + '%'; });
    rig.floor.forEach(function (b, j) { b.x = j ? 86 : 14; b.style.left = b.x + '%'; });
  }

  /* angle (deg) that points a fixture at x% to a target point (tx %, ty vh) */
  function aimTop(x, tx, ty) {
    var dx = (tx - x) / 100 * innerWidth, dy = (ty + 6) / 100 * innerHeight;
    return -Math.atan2(dx, dy) * 180 / Math.PI;
  }
  function aimFloor(x, tx, ty) {
    var dx = (tx - x) / 100 * innerWidth, dy = (106 - ty) / 100 * innerHeight;
    return Math.atan2(dx, dy) * 180 / Math.PI;
  }
  function setB(b, rot, w, o, tBeats, toMs) {
    var B = beatMs() / speed();
    b.lrot = rot; b.lw = +w || 1;                                   // the look's own angle/width (the follow layer works off them)
    b.style.setProperty('--rot', rot.toFixed(2) + 'deg');
    b.style.setProperty('--w', w);
    if (b.i != null && show && show.mask && !show.mask(b.i)) o = 0;
    b.style.setProperty('--o', (o * E).toFixed(3));
    b.style.setProperty('--t', Math.max(80, tBeats * B) + 'ms');
    b.style.setProperty('--to', (toMs == null ? 220 : toMs) + 'ms');
  }
  function hit() {
    rig.wash.classList.add('hit');
    requestAnimationFrame(function () { requestAnimationFrame(function () { rig.wash.classList.remove('hit'); }); });
  }
  function floorOff(t) { rig.floor.forEach(function (b) { setB(b, 0, 1, 0, t || 2); }); }
  function mid(i) { return i - (TOP - 1) / 2; }

  /* ---------- the looks ----------
     each: { len: [beats…], step(k, c) }  — step runs every beat; k = beat inside the look,
     c = scratch object for parameters rolled at the start of the look. */
  var TT = TOP - 1;
  function all(fn) { rig.top.forEach(fn); }
  function floors(fn) { rig.floor.forEach(fn); }
  function sym(c) { if (c.m == null) c.m = Math.random() < .5 ? 1 : -1; return c.m; }   // mirror roll

  var LOOKS = {
    /* — slow & imposing — */
    cathedral: { len: [8, 16], step: function (k, c) {
      if (k % 8) return; var sp = rnd(5, 11);
      all(function (b, i) { setB(b, -mid(i) * sp, 1, 1, 4); }); floorOff(); } },
    slowburn: { len: [16], step: function (k, c) {
      if (k % 8) return; c.a = (c.a || rnd(-20, 20)) * -1;
      all(function (b, i) { setB(b, c.a + mid(i) * rnd(-2, 2), .8, .85, 8); }); floorOff(); } },
    monolith: { len: [4, 8], step: function (k) {
      if (k) return;
      all(function (b, i) { var m = i === 3 || i === 4; setB(b, m ? (i === 3 ? 2 : -2) : 0, m ? 1.5 : 1, m ? 1 : 0, 2, 700); }); floorOff(); } },
    tunnel: { len: [8], step: function (k, c) {
      if (k % 4) return; var d = rnd(18, 34) * (k % 8 ? .7 : 1);
      all(function (b, i) { setB(b, i < TOP / 2 ? -d : d, .6, 1, 3); }); floorOff(); } },
    floorsolo: { len: [8, 16], step: function (k, c) {
      if (k % 4) return; var a = (k % 8 ? -1 : 1) * rnd(15, 35);
      all(function (b) { setB(b, 0, 1, 0, 2, 600); });
      floors(function (b, j) { setB(b, j ? -a : a, 1.3, 1, 4); }); } },

    /* — focus — */
    converge: { len: [8], step: function (k, c) {
      if (!k) c.ty = rnd(55, 85);
      var tx = 50 + Math.sin(k / 8 * Math.PI * 2) * 8;
      all(function (b) { setB(b, aimTop(b.x, tx, c.ty), .7, 1, k ? 1 : 3); });
      floors(function (b) { setB(b, aimFloor(b.x, tx, c.ty), .8, .8, k ? 1 : 3); }); } },
    twinfocus: { len: [8], step: function (k, c) {
      if (k % 4) return; var y = rnd(50, 80), l = rnd(22, 35), r = 100 - l;
      if (k) { var t = l; l = r; r = t; }
      all(function (b, i) { setB(b, aimTop(b.x, i < TOP / 2 ? l : r, y), .6, 1, 2); });
      floors(function (b, j) { setB(b, aimFloor(b.x, j ? l : r, y), .8, .9, 2); }); } },
    crossfire: { len: [8], step: function (k, c) {
      var flip = k % 4 < 2 ? 1 : -1;
      all(function (b, i) { setB(b, aimTop(b.x, flip > 0 ? 100 - b.x : b.x, 95) * .9, .7, i % 2 ? 1 : .6, 1.5); });
      floors(function (b, j) { setB(b, aimFloor(b.x, j ? 10 : 90, 5) * flip, 1, 1, 1.5); }); } },

    /* — movement — */
    sweep: { len: [8, 16], step: function (k, c) {
      if (!k) c.amp = rnd(22, 40);
      if (k % 2) return; var dir = (k / 2) % 2 ? 1 : -1;
      all(function (b) { setB(b, dir * c.amp, 1, 1, 2); });
      floors(function (b) { setB(b, -dir * c.amp * .8, 1, .9, 2); }); } },
    scissor: { len: [8], step: function (k, c) {
      var a = (k % 2 ? 1 : -1) * (c.a || (c.a = rnd(16, 30)));
      all(function (b, i) { setB(b, i < TOP / 2 ? a : -a, .8, 1, .9); }); floorOff(1); } },
    pendulum: { len: [8, 16], step: function (k, c) {
      if (!k) { c.ph = rnd(.35, .9); c.amp = rnd(18, 32); }
      all(function (b, i) { setB(b, Math.sin(k * Math.PI / 2 + i * c.ph) * c.amp, .8, 1, 1); }); floorOff(1); } },
    spiral: { len: [8, 16], step: function (k, c) {
      var m = sym(c);
      all(function (b, i) { var a = ((k * 11 + i * 23) % 90) - 45; setB(b, a * m, .7, .5 + .5 * Math.abs(Math.cos((k + i) / 2)), 1); }); floorOff(1); } },
    split: { len: [8], step: function (k, c) {
      var a = (k % 2 ? 1 : -1) * 28;
      all(function (b, i) { if (i < TOP / 2) setB(b, -mid(i) * 8, 1, 1, 2); else setB(b, a, .8, 1, 1); });
      if (k % 4 === 0) { var t = sym(c); c.m = -t; } floorOff(1); } },

    /* — rhythm — */
    curtain: { len: [4, 8], step: function (k) {
      all(function (b, i) { setB(b, 0, .35, (k % 2 === i % 2) ? 1 : .2, k ? .2 : 2, 60); }); floorOff(1); } },
    chase: { len: [8], step: function (k, c) {
      var m = sym(c), on = m > 0 ? k % TOP : TT - k % TOP;
      all(function (b, i) { var d = Math.abs(i - on); setB(b, -mid(i) * 4, .9, d === 0 ? 1 : d === 1 ? .35 : .06, .5, 90); }); floorOff(1); } },
    bounce: { len: [8, 16], step: function (k) {                     // chase that ping-pongs
      var p = k % (TT * 2), on = p < TOP ? p : TT * 2 - p;
      all(function (b, i) { var d = Math.abs(i - on); setB(b, -mid(i) * 6, .8, d === 0 ? 1 : d === 1 ? .4 : .08, .5, 80); }); floorOff(1); } },
    wave: { len: [8], step: function (k) {
      all(function (b, i) { setB(b, -mid(i) * 5, .9, .25 + .75 * (.5 + .5 * Math.sin((k - i) * Math.PI / 4)), 1, 200); }); floorOff(1); } },
    gate: { len: [8], step: function (k, c) {                        // offbeat only
      if (!k) c.sp = rnd(4, 9);
      all(function (b, i) { setB(b, -mid(i) * c.sp, 1, k % 2 ? 1 : .05, 1, 50); }); floorOff(1); } },
    pop: { len: [4, 8], step: function (k) {                         // random fixtures pop per beat
      all(function (b, i) { var on = Math.random() < .35; setB(b, rnd(-35, 35), on ? 1.1 : .8, on ? 1 : .05, .25, 50); }); floorOff(1); } },
    rise: { len: [8], step: function (k) {                           // build: narrow → wide fan
      var t = k / 7;
      all(function (b, i) { setB(b, -mid(i) * (2 + t * 12), .3 + t * .9, .3 + t * .7, 1); });
      floors(function (b, j) { setB(b, 0, 1, t > .6 ? t : 0, 1); }); } },
    hits: { len: [4], step: function (k) {
      var sp = pick([0, 8, 14]);
      all(function (b, i) { setB(b, -mid(i) * sp, 1.1, 1, .15, 40); });
      setTimeout(function () { all(function (b) { b.style.setProperty('--o', .15 * E); }); }, beatMs() * .45);
      hit(); } },
    chaos: { len: [4, 8], step: function (k) {                       // every fixture its own way
      if (k % 2) return;
      all(function (b) { setB(b, rnd(-50, 50), rnd(.4, 1.3), rnd(.4, 1), 1.6); });
      floors(function (b) { setB(b, rnd(-40, 40), 1, rnd(0, 1), 1.6); }); } },
    /* — crossings (T's favourite: the two halves of the rig cross into an X behind the garment) — */
    xcross: { len: [8, 16], step: function (k, c) {                 // hold a big X, crossing point drifts
      if (k % 2) return;
      if (!k) { c.ph = rnd(0, 6.28); c.dir = sym(c); }
      var t = c.ph + c.dir * k * Math.PI / 6, y = 65 + Math.sin(t) * 20, s = Math.cos(t * 1.3) * 22;
      all(function (b) { setB(b, aimTop(b.x, 100 - b.x + s, y), .8, 1, 2); });
      floors(function (b) { setB(b, aimFloor(b.x, 100 - b.x - s, 100 - y), 1.1, 1, 2); }); } },
    xroam: { len: [8, 16], step: function (k, c) {                  // every beam crosses at one point that roams the screen
      if (!k) { c.a = rnd(0, 6.28); c.b = rnd(0, 6.28); c.wa = rnd(.35, .6); c.wb = rnd(.5, .9); }
      var tx = 50 + Math.sin(c.a + k * c.wa) * 34, ty = 50 + Math.sin(c.b + k * c.wb) * 26;
      all(function (b) { setB(b, aimTop(b.x, tx, ty), .65, 1, 1); });
      floors(function (b) { setB(b, aimFloor(b.x, tx, ty), .8, .9, 1); }); } },
    xbreathe: { len: [8, 16], step: function (k, c) {               // X opens and closes, smooth
      if (!k) { c.lo = rnd(8, 14); c.hi = rnd(24, 36); }
      var d = c.lo + (c.hi - c.lo) * (.5 + .5 * Math.sin(k * Math.PI / 4));
      all(function (b, i) { setB(b, (i < TOP / 2 ? -1 : 1) * d, .75, 1, 1); });
      floors(function (b, j) { setB(b, (j ? -1 : 1) * d * 1.1, 1.1, .9, 1); }); } },
    xstrobe: { len: [8], step: function (k, c) {                    // X held, halves trade hits on the beat
      if (!k) c.d = rnd(16, 30);
      all(function (b, i) { var L = i < TOP / 2; setB(b, (L ? -1 : 1) * c.d, .7, (k % 2 === (L ? 0 : 1)) ? 1 : .12, k ? .2 : 2, 60); });
      floors(function (b, j) { setB(b, (j ? -1 : 1) * c.d, 1.1, (k % 2 === j) ? 1 : .15, k ? .2 : 2, 60); }); } },
    blackout: { len: [4], step: function (k) {
      if (k) return; all(function (b) { setB(b, 0, 1, 0, 1, 500); }); floorOff(); } }
  };

  /* ---------- the set: sections with an energy arc ----------
     intro → build → drop → breakdown, then round again with different lengths and
     different looks. Each section draws looks only from its own pool and won't reuse
     anything from the last three looks, so a full arc takes minutes and never plays
     out the same way twice. */
  var SECTIONS = {
    intro:     { len: [16, 32], e: .7,  pool: ['slowburn', 'cathedral', 'monolith', 'floorsolo', 'tunnel', 'converge', 'xcross', 'xbreathe', 'xroam'] },
    build:     { len: [16, 32], e: .85, pool: ['rise', 'chase', 'bounce', 'wave', 'gate', 'pendulum', 'curtain', 'twinfocus', 'xbreathe', 'xstrobe', 'tunnel', 'xroam', 'sweep'] },
    drop:      { len: [32, 48, 64], e: 1, pool: ['sweep', 'scissor', 'hits', 'pop', 'crossfire', 'spiral', 'split', 'chaos', 'converge', 'twinfocus', 'pendulum', 'cathedral', 'xcross', 'xbreathe', 'xstrobe', 'tunnel', 'xroam'] },
    breakdown: { len: [8, 16], e: .55, pool: ['blackout', 'monolith', 'slowburn', 'floorsolo', 'cathedral', 'xcross'] }
  };
  var E = 1;                                    // section energy → scales beam opacity

  /* section flow is a weighted walk, not a fixed list, so the arc itself varies */
  var FLOW = {
    intro:     [['build', 1]],
    build:     [['drop', .8], ['breakdown', .2]],                    // .2 = fake-out
    drop:      [['breakdown', .5], ['drop', .25], ['build', .25]],
    breakdown: [['build', .7], ['intro', .3]]
  };
  function nextSection(prev) {
    var r = Math.random(), acc = 0, opts = FLOW[prev];
    for (var i = 0; i < opts.length; i++) { acc += opts[i][1]; if (r <= acc) return opts[i][0]; }
    return opts[0][0];
  }

  /* fixture masks: which heads are lit for a look — multiplies every look ×5 */
  var MASKS = [
    [.55, function () { return true; }],
    [.12, function (i) { return i % 2 === 0; }],
    [.12, function (i) { return i % 2 === 1; }],
    [.10, function (i) { return i >= 2 && i <= 5; }],
    [.11, function (i) { return i <= 1 || i >= 6; }]
  ];
  function rollMask() {
    var r = Math.random(), acc = 0;
    for (var i = 0; i < MASKS.length; i++) { acc += MASKS[i][0]; if (r <= acc) return MASKS[i][1]; }
    return MASKS[0][1];
  }

  /* no-repeat window: a "combo" = look + fixture mask. Any combo used in the last
     NOREPEAT beats (≈3 min at 124 BPM) is off the table; pick at random from the rest
     (mask-weighted). Parameters inside each look are re-rolled every time on top. */
  var NOREPEAT = 380, usedAt = {};
  var CROSS = ['xcross', 'xbreathe', 'xstrobe', 'xroam', 'tunnel', 'scissor', 'crossfire',   // crossings + beams moving
               'sweep', 'pendulum', 'spiral', 'converge', 'twinfocus'];                          // round the screen: ~2.5× as often
  var MASKLESS = ['blackout', 'monolith', 'chase', 'bounce', 'pop'];
  function nextCombo(sec, beat) {
    var cands = [];
    SECTIONS[sec].pool.forEach(function (n) {
      var ms = MASKLESS.indexOf(n) > -1 ? [-1] : [0, 1, 2, 3, 4];
      ms.forEach(function (m) {
        var key = n + '/' + m;
        if (usedAt[key] == null || beat - usedAt[key] >= NOREPEAT) cands.push({ n: n, m: m, w: (m < 0 ? .5 : MASKS[m][0]) * (CROSS.indexOf(n) > -1 ? 2.5 : 1) });
      });
    });
    if (!cands.length) {                                   // fallback: oldest combo in pool
      var best = null;
      SECTIONS[sec].pool.forEach(function (n) { [-1, 0, 1, 2, 3, 4].forEach(function (m) { var t = usedAt[n + '/' + m]; if (t != null && (!best || t < best.t)) best = { n: n, m: m, t: t }; }); });
      cands = [best];
      best.w = 1;
    }
    var tot = cands.reduce(function (x, c) { return x + c.w; }, 0), r = Math.random() * tot, c;
    for (var i = 0; i < cands.length; i++) { r -= cands[i].w; if (r <= 0) { c = cands[i]; break; } }
    c = c || cands[cands.length - 1];
    usedAt[c.n + '/' + c.m] = beat;
    return c;
  }


  /* ================= HELLO: the lights say hi =================
     The first time someone lands in a visit, the rig opens with a short welcome
     (~4s) before the show takes over — no words, just the beams. One of these is
     picked at random. ?hi=1 forces one, ?hi=<name> forces that one. Any scroll
     just lets it finish; the follow layer stays out of it until it's done. */
  function dark() { all(function (b) { setB(b, 0, .4, 0, .1, 0); }); floorOff(.1); }
  function fan(sp, t) { all(function (b, i) { setB(b, -mid(i) * sp, 1, 1, t || 2, 400); }); }
  var HELLO = {
    wave: { len: 10, step: function (k) {                           // light up, then the whole rig waves like a hand
      if (!k) return dark();
      if (k === 1) return all(function (b, i) { setB(b, -mid(i) * 3, .7, 1, 1, 500); });
      if (k < 8) { var d = (k % 2 ? 1 : -1) * 24;
        all(function (b, i) { setB(b, d - mid(i) * 2, .7, 1, 1); });
        return floors(function (b) { setB(b, -d * .8, 1, .8, 1, 300); }); }
      if (k === 8) { hit(); fan(8); floorOff(2); } } },
    bloom: { len: 10, step: function (k) {                          // lights come on from the middle out, then open into a fan
      if (!k) return dark();
      if (k <= 4) return all(function (b, i) { var on = Math.abs(mid(i)) - .5 <= k - 1; setB(b, 0, .35, on ? 1 : 0, .5, 250); });
      if (k === 5) { hit(); fan(9); floors(function (b, j) { setB(b, j ? -10 : 10, 1.1, 1, 2, 400); }); } } },
    spotlight: { len: 9, step: function (k) {                       // every beam finds the centre, flashes twice — hi hi — then opens
      if (!k) return dark();
      if (k === 1) { all(function (b) { setB(b, aimTop(b.x, 50, 48), .55, 1, 1.5, 500); });
        return floors(function (b) { setB(b, aimFloor(b.x, 50, 48), .7, .9, 1.5, 500); }); }
      if (k === 3 || k === 4) return hit();
      if (k === 6) { fan(7, 2.5); floorOff(2); } } },
    domino: { len: 12, step: function (k) {                         // one by one, left to right, each beam drops into place
      if (!k) return all(function (b) { setB(b, 34, .6, 0, .1, 0); }), floorOff(.1);
      if (k <= TOP) { var b = rig.top[k - 1]; return setB(b, -mid(k - 1) * 6, .8, 1, .9, 120); }
      if (k === TOP + 1) { hit(); floors(function (b, j) { setB(b, j ? -16 : 16, 1.1, 1, 1.5, 300); }); } } },
    curtain: { len: 9, step: function (k) {                         // closed together in the middle, then pulled open
      if (!k) return dark();
      if (k === 1) return all(function (b) { setB(b, aimTop(b.x, 50, 92), .3, 1, 1, 400); });
      if (k === 3) { hit(); all(function (b, i) { setB(b, -mid(i) * 4, .6, 1, 1.5); }); return; }
      if (k === 5) { fan(11, 2); floors(function (b, j) { setB(b, j ? -22 : 22, 1.1, 1, 2, 400); }); } } },
    findyou: { len: 10, step: function (k, c) {                     // searchlights sweep the room… and land on you
      if (!k) return dark();
      if (k <= 4) { var d = (k % 2 ? -1 : 1) * 30; return all(function (b, i) { setB(b, d - mid(i) * 2, .6, 1, 1, 400); }); }
      if (k === 5) { var tx = eye.seen ? eye.x : 50, ty = eye.seen ? eye.y : 55; hit();
        all(function (b) { setB(b, aimTop(b.x, tx, ty), .5, 1, .8); });
        return floors(function (b) { setB(b, aimFloor(b.x, tx, ty), .7, 1, .8, 300); }); }
      if (k === 8) { fan(6, 2); floorOff(2); } } },
    xmark: { len: 9, step: function (k) {                           // a big X snaps on, winks shut and open, then fans out
      if (!k) return dark();
      function x(d) { all(function (b, i) { setB(b, (i < TOP / 2 ? -1 : 1) * d, .75, 1, .6, 150); });
        floors(function (b, j) { setB(b, (j ? -1 : 1) * d * 1.1, 1.1, 1, .6, 150); }); }
      if (k === 1) { hit(); return x(28); }
      if (k === 3) return x(8);
      if (k === 4) { hit(); return x(28); }
      if (k === 6) { fan(8); floorOff(2); } } }
  };
  function helloName() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return null;
    var m = /[?&]hi=([a-z0-9]+)/.exec(location.search), force = m && m[1] !== 'text';
    try { if (!force && sessionStorage.getItem('maudHiBeams')) return null; sessionStorage.setItem('maudHiBeams', '1'); } catch (e) {}
    if (force && HELLO[m[1]]) return m[1];
    return pick(Object.keys(HELLO));
  }

  function startShow() {
    if (show) return;
    if (!rig) buildRig();
    show = { sec: 'intro', sk: 0, slen: 0, look: null, k: 0, len: 0, beat: 0, ctx: {}, mask: null, hello: null, hk: 0, hctx: {} };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { E = 1; LOOKS.cathedral.step(0, {}); return; }
    show.hello = helloName();
    (function tick() {
      if (!show) return;
      if (show.hello) {                                                // the welcome plays first, scroll or not
        if (frozen) unfreeze();
        E = 1; show.mask = null;
        HELLO[show.hello].step(show.hk, show.hctx);
        if (++show.hk >= HELLO[show.hello].len) show.hello = null;
        show.timer = setTimeout(tick, beatMs());
        return;
      }
      var live = !document.hidden && (Date.now() - lastScroll < IDLE || !show.beat);
      if (live) {
        if (frozen) unfreeze();
        if (!show.slen || show.sk >= show.slen) {                     // new section
          show.sec = show.slen ? nextSection(show.sec) : 'intro';
          var sec = SECTIONS[show.sec];
          show.slen = pick(sec.len); show.sk = 0; show.len = 0; E = sec.e;
          hit();
        }
        if (!show.look || show.k >= show.len) {                       // new look
          var combo = nextCombo(show.sec, show.beat);
          show.look = combo.n; show.mask = combo.m < 0 ? null : MASKS[combo.m][1];
          show.k = 0; show.ctx = {};
          show.len = Math.min(pick(LOOKS[show.look].len), show.slen - show.sk);
          if (Math.random() < .3) hit();
        }
        LOOKS[show.look].step(show.k, show.ctx);
        show.k++; show.sk++; show.beat++;
      }
      show.timer = setTimeout(tick, beatMs());
    })();
  }
  /* the show only plays while the customer is scrolling: every scroll / wheel / touch
     keeps it live for IDLE ms (≈2 beats), then everything freezes where it is. */
  var lastScroll = 0, IDLE = 700, idleT = null, frozen = false;
  function poke() {
    lastScroll = Date.now();
    if (frozen) unfreeze();
    clearTimeout(idleT);
    idleT = setTimeout(freeze, IDLE);
  }
  /* freeze = stop dead mid-move: pin every beam to its current on-screen value */
  function freeze() {
    if (!show || !rig || frozen || show.hello) return;
    frozen = true;
    rig.querySelectorAll('b').forEach(function (b) {
      var cs = getComputedStyle(b);
      b.style.setProperty('--rot', cs.rotate === 'none' ? '0deg' : cs.rotate);
      b.style.setProperty('--w', cs.scale === 'none' ? 1 : cs.scale.split(' ')[0]);
      b.style.setProperty('--o', cs.opacity);
    });
    rig.classList.add('is-paused');
  }
  function unfreeze() { frozen = false; if (rig) rig.classList.remove('is-paused'); }
  addEventListener('scroll', poke, { passive: true });
  addEventListener('wheel', poke, { passive: true });
  addEventListener('touchmove', poke, { passive: true });

  /* ================= ALIVE: the rig watches the customer =================
     On top of the show, every fixture turns to look at the cursor (or the finger on a
     phone), each head with its own lag so they move like living things, not a grid.
     Moving = they lock on harder; going still = they drift back toward the show and
     freeze. Scroll speed swings the whole rig on a spring (overshoot + wobble), fast
     flicks and taps fire a flash, and on phones that allow it, tilting the phone
     steers the lights. Runs as a CSS transform layered on top of the look's rotate. */
  var eye = { x: 50, y: 55, px: 50, py: 55, seen: false, at: 0, f: 0, sv: 0, sw: 0, swv: 0, lastY: scrollY, lastT: 0, flash: 0, tilt: null };
  function lookAt(x, y, t) {
    var nx = x / innerWidth * 100, ny = y / innerHeight * 100, now = Date.now();
    if (eye.seen && eye.lastT) {                                      // flick → flash
      var dt = Math.max(16, now - eye.lastT), sp = Math.hypot((nx - eye.x) * innerWidth / 100, (ny - eye.y) * innerHeight / 100) / dt;
      if (sp > 4.2 && now - eye.flash > 900 && show && rig) { eye.flash = now; hit(); }
    }
    eye.x = nx; eye.y = ny; eye.seen = true; eye.at = now; eye.lastT = now;
    poke();
  }
  addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') lookAt(e.clientX, e.clientY); }, { passive: true });
  addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) { eye.lastT = 0; lookAt(t.clientX, t.clientY); } }, { passive: true });
  addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) lookAt(t.clientX, t.clientY); }, { passive: true });
  addEventListener('pointerdown', function () { if (show && rig) { hit(); poke(); } }, { passive: true });
  addEventListener('deviceorientation', function (e) {                // tilt steers (Android / allowed iOS)
    if (e.gamma == null) return;
    eye.tilt = { x: Math.max(-1, Math.min(1, e.gamma / 35)), y: Math.max(-1, Math.min(1, ((e.beta || 45) - 45) / 35)) };
  }, { passive: true });

  /* the follow rotation sits inside the look's width scale, so undo that squash */
  function rotFor(b) {
    var a = Math.max(-80, Math.min(80, b.fo)) * Math.PI / 180;
    return (Math.atan(Math.tan(a) / (b.lw || 1)) * 180 / Math.PI).toFixed(2);
  }
  function aliveLoop() {
    requestAnimationFrame(aliveLoop);
    if (!show || !rig || frozen || document.hidden || cur() !== 'beams') return;
    var now = Date.now();
    /* scroll velocity → spring swing */
    var y = scrollY, v = y - eye.lastY; eye.lastY = y;
    eye.sv += (v - eye.sv) * .25;
    var target = Math.max(-16, Math.min(16, -eye.sv * .55));
    eye.swv = (eye.swv + (target - eye.sw) * .09) * .86; eye.sw += eye.swv;
    /* where they look: cursor/finger, nudged by tilt; with no input yet, they scan slowly */
    var tx = eye.x, ty = eye.y;
    if (!eye.seen) { var t = now / 2600; tx = 50 + Math.sin(t) * 30; ty = 55 + Math.sin(t * 1.7) * 18; }
    if (eye.tilt) { tx += eye.tilt.x * 22; ty += eye.tilt.y * 16; }
    eye.px += (tx - eye.px) * .06; eye.py += (ty - eye.py) * .06;
    /* attention: locks on while they move, relaxes (but keeps watching) when they pause */
    var since = now - eye.at, want = show.hello ? 0 : !eye.seen ? .3 : since < 900 ? .6 : since < 2500 ? .42 : .3;
    if (show.hello) { eye.sw *= .8; eye.swv = 0; }
    eye.f += (want - eye.f) * .05;
    rig.top.forEach(function (b, i) {
      if (b.lag == null) b.lag = .05 + ((i * 37) % 9) / 100;          // each head its own reaction time
      var aim = aimTop(b.x, eye.px, eye.py), base = b.lrot || 0;
      var d = eye.f * (aim - base) + eye.sw * (1 - Math.abs(mid(i)) / TOP);
      b.fo = (b.fo || 0) + (d - (b.fo || 0)) * b.lag;
      b.style.transform = 'rotate(' + rotFor(b) + 'deg)';
    });
    rig.floor.forEach(function (b, j) {
      if (b.lag == null) b.lag = j ? .07 : .11;
      var aim = aimFloor(b.x, eye.px, eye.py), base = b.lrot || 0;
      var d = eye.f * .8 * (aim - base) - eye.sw * .7;
      b.fo = (b.fo || 0) + (d - (b.fo || 0)) * b.lag;
      b.style.transform = 'rotate(' + rotFor(b) + 'deg)';
    });
  }
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) requestAnimationFrame(aliveLoop);

  /* ================= GUIDE: the lights help someone who's stuck =================
     Little detectors watch for hesitation (flip-flopping between two options, stalling
     on a product, a full cart and endless scrolling, opening and closing the cart, heading
     for the exit). When one trips, the rig drops the show, every beam swings onto ONE
     thing — the option they kept coming back to, the add-to-cart, the cart, checkout —
     and that thing glows. Any tap ends it. Each detector fires once per visit, nothing in
     the first 20s, 45s between nudges, no motion-reduced users get only the glow.
     ?nudge=flip|stall|cart|drawer|exit fires one on demand for testing. */
  var guide = null, RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function center(el) {
    var r = el.getBoundingClientRect();
    return { x: (r.left + r.width / 2) / innerWidth * 100, y: (r.top + r.height / 2) / innerHeight * 100, ok: r.width > 0 && r.bottom > 0 && r.top < innerHeight };
  }
  function aimAll(el, w, o, t) {
    var c = center(el);
    all(function (b) { setB(b, aimTop(b.x, c.x, c.y), w, o, t, 300); });
    floors(function (b) { setB(b, aimFloor(b.x, c.x, c.y), w * 1.3, o * .9, t, 300); });
  }
  function startGuide(el, why) {
    if (!el) return false;
    endGuide();
    el.classList.add('maud-nudge');
    guide = { el: el, why: why, k: 0, t0: Date.now() };
    try { console.debug('[maud guide]', why, el); } catch (e) {}
    if (show && rig && cur() === 'beams' && !RM) {
      if (frozen) unfreeze();
      clearTimeout(show.timer);
      (function gtick() {                                     // the guide's own beat, ahead of the show
        if (!guide || !show) return;
        var k = guide.k++;
        if (!guide.el.isConnected) return endGuide();
        E = 1; show.mask = null;
        if (k === 0) { hit(); aimAll(guide.el, .45, 1, 1.2); }
        else if (k < 12) { aimAll(guide.el, k % 2 ? .35 : .55, 1, .5); if (k === 3 || k === 6) hit(); }
        else return endGuide();
        show.timer = setTimeout(gtick, beatMs());
      })();
    } else {
      guide.timer = setTimeout(endGuide, 6000);
    }
    return true;
  }
  function endGuide() {
    if (!guide) return;
    var g = guide; guide = null;
    clearTimeout(g.timer);
    g.el.classList.remove('maud-nudge');
    if (show) { clearTimeout(show.timer); show.look = null; show.timer = setTimeout(function tickAgain() { var s = show; show = null; if (s) { startShow(); show.sec = s.sec; show.beat = s.beat; } }, beatMs()); }
  }
  addEventListener('pointerdown', function () { if (guide && Date.now() - guide.t0 > 400) endGuide(); }, { passive: true, capture: true });
  addEventListener('keydown', function () { if (guide) endGuide(); });

  /* ---------- the rules: once per visit each, quiet start, cooldown ---------- */
  var NUDGE = (function () {
    var t0 = Date.now(), last = 0, done = {};
    try { t0 = +sessionStorage.getItem('maudVisitT') || (sessionStorage.setItem('maudVisitT', t0), t0); done = JSON.parse(sessionStorage.getItem('maudNudged') || '{}'); } catch (e) {}
    return function (name, el, force) {
      var now = Date.now();
      if (!force && (done[name] || now - t0 < 20000 || now - last < 45000 || guide)) return false;
      if (!el || !center(el).ok) return false;
      if (!startGuide(el, name)) return false;
      done[name] = 1; last = now;
      try { sessionStorage.setItem('maudNudged', JSON.stringify(done)); } catch (e) {}
      return true;
    };
  })();

  /* ---------- what's in the cart (priority add-on doesn't count) ---------- */
  var cart = { n: 0, changed: Date.now() };
  function readCart() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0; (c.items || []).forEach(function (it) { if (it.handle !== 'priority-fulfillment') n += it.quantity; });
      if (n !== cart.n) { cart.n = n; cart.changed = Date.now(); }
    }).catch(function () {});
  }
  document.addEventListener('cart:refresh', function () { setTimeout(readCart, 300); });
  document.addEventListener('submit', function (e) { if (/\/cart\/add/.test(e.target.action || '')) { cart.changed = Date.now(); setTimeout(readCart, 1500); } }, true);
  function visible(sel) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) { if (els[i].offsetParent !== null && center(els[i]).ok) return els[i]; }
    return null;
  }
  function atc() { return visible('.product-form__add-button, form[action*="/cart/add"] [type="submit"]'); }
  function fcart() { return visible('.dtg-fcart') || visible('[aria-controls="mini-cart"]'); }

  /* 1. flip-flop: A↔B↔A↔B on one option inside 30s → point at the one they lingered on */
  var picks = {};                                              // option name → [{v, t, el}]
  function labelFor(input) {
    return (input.id && document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]')) || input;
  }
  function picked(name, value, el) {
    var now = Date.now(), h = picks[name] = (picks[name] || []).filter(function (p) { return now - p.t < 30000; });
    if (h.length && h[h.length - 1].v === value) return;
    h.push({ v: value, t: now, el: el });
    if (h.length < 4) return;
    var vals = {}; h.slice(-5).forEach(function (p) { vals[p.v] = 1; });
    var tail = h.slice(-4), alt = tail[0].v === tail[2].v && tail[1].v === tail[3].v && tail[0].v !== tail[1].v;
    if (!alt || Object.keys(vals).length > 2) return;
    /* winner: most time spent on it, ties → the one they came back to last */
    var dwell = {}, lastEl = {};
    h.forEach(function (p, i) { var nx = h[i + 1] ? h[i + 1].t : now; dwell[p.v] = (dwell[p.v] || 0) + (nx - p.t); lastEl[p.v] = p.el; });
    var a = tail[2].v, b = tail[3].v, win = Math.abs(dwell[a] - dwell[b]) < 800 ? tail[3].v === b ? a : b : dwell[a] > dwell[b] ? a : b;
    if (NUDGE('flip', lastEl[win])) picks[name] = [];
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('input[type="radio"][name^="option"]')) picked(t.name, t.value, labelFor(t));
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dtg-sides__btn');
    if (b) picked('side', b.dataset.side, b);
  }, true);

  /* 2. stall on a product: 45s+, lots of up-and-down scrolling, nothing added → the add-to-cart */
  var dir = 0, lastY2 = scrollY, turns = 0, swing = 0, pageT = Date.now(), scrolled = 0, scrollLog = [];
  addEventListener('scroll', function () {
    var y = scrollY, d = y - lastY2; lastY2 = y;
    if (!d) return;
    scrollLog.push({ t: Date.now(), d: Math.abs(d) });
    var s = d > 0 ? 1 : -1;
    swing += Math.abs(d);
    if (s !== dir) { if (swing > 150) turns++; swing = 0; dir = s; }
  }, { passive: true });
  /* 5. exit: pointer leaves through the top (desktop) / fast flick back to the top (phone) with a cart */
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && cart.n > 0) NUDGE('exit', fcart());
  });
  var flickY = scrollY, flickT = Date.now();
  addEventListener('scroll', function () {
    var now = Date.now(), y = scrollY;
    if (now - flickT > 250) { if (cart.n > 0 && flickY - y > innerHeight * 1.5 && y < 120) NUDGE('exit', fcart()); flickY = y; flickT = now; }
  }, { passive: true });

  /* 4. cart opened and closed twice, no checkout → checkout button the next time it opens */
  var drawerCloses = 0;
  function watchDrawer() {
    var d = document.getElementById('mini-cart');
    if (!d) return;
    var was = d.hasAttribute('open');
    new MutationObserver(function () {
      var open = d.hasAttribute('open');
      if (open === was) return; was = open;
      if (!open) { drawerCloses++; return; }
      readCart();
      if (drawerCloses >= 2) setTimeout(function () { NUDGE('drawer', visible('#mini-cart [name="checkout"]')); }, 700);
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  setInterval(function () {
    if (document.hidden || guide) return;
    var now = Date.now();
    scrollLog = scrollLog.filter(function (s) { return now - s.t < 60000; });
    var dist = scrollLog.reduce(function (a, s) { return a + s.d; }, 0);
    /* 2 */ if (/\/products\//.test(location.pathname) && now - pageT > 45000 && turns >= 4 && now - cart.changed > 45000) NUDGE('stall', atc());
    /* 3 */ if (cart.n > 0 && now - cart.changed > 60000 && dist > innerHeight * 3 && !/\/products\//.test(location.pathname) || (cart.n > 0 && now - cart.changed > 90000 && dist > innerHeight * 4)) NUDGE('cart', fcart());
  }, 2000);

  /* test switch */
  function testNudge() {
    var m = /[?&]nudge=(flip|stall|cart|drawer|exit)/.exec(location.search);
    if (!m) return;
    setTimeout(function () {
      var n = m[1], el;
      if (n === 'flip') { var r = document.querySelectorAll('input[type="radio"][name^="option"]'); el = r[1] ? labelFor(r[1]) : null; }
      else if (n === 'stall') el = atc();
      else if (n === 'drawer') { var o = document.querySelector('[aria-controls="mini-cart"]'); if (o) o.click(); return setTimeout(function () { NUDGE(n, visible('#mini-cart [name="checkout"]'), true); }, 1200); }
      else el = fcart();
      if (el && el.scrollIntoView && n !== 'cart' && n !== 'exit') el.scrollIntoView({ block: 'center' });
      setTimeout(function () { NUDGE(n, el, true); }, 600);
    }, 2500);
  }

  function stopShow() { if (show) { clearTimeout(show.timer); show = null; } }
  function sync() { if (layer) { if (cur() === 'beams') startShow(); else stopShow(); } }

  function init() {
    readCart(); watchDrawer(); testNudge();
    layer = document.querySelector('.maud-bg');
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'maud-bg'; layer.setAttribute('aria-hidden', 'true');
      layer.innerHTML = new Array(13).join('<i></i>');
      document.body.appendChild(layer);
    }
    sync();
    var showPick = false, cfg = document.getElementById('maud-motion-bg-settings');
    try { showPick = sessionStorage.getItem('maudBgPick') === '1'; } catch (e) {}
    if (cfg && cfg.dataset.switcher === 'true' && !(window.Shopify && Shopify.designMode)) showPick = true;
    if (!showPick || document.querySelector('.maud-bg-pick')) return;
    var w = document.createElement('div');
    w.className = 'maud-bg-pick';
    w.innerHTML = '<span>BG</span>' + MODES.map(function (m) {
      return '<button type="button" data-m="' + m + '" aria-pressed="' + (m === cur()) + '">' + m + '</button>';
    }).join('');
    w.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) set(b.dataset.m); });
    document.body.appendChild(w);
  }

  /* theme editor: re-apply when the section's settings change */
  document.addEventListener('shopify:section:load', function () {
    var cfg = document.getElementById('maud-motion-bg-settings');
    if (cfg && !root.hasAttribute('data-maud-bg-override')) root.setAttribute('data-maud-bg', cfg.dataset.mode);
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
